module.exports = __webpack_public_path__ + "static/media/instagram.3f48fba9.png";